<template>
  <div>
    <v-container fluid>
      <v-form>
        <v-row class="align-center mb-3 pt-3 pl-1">
          <v-btn @click="backButton()" color="orange" class="white--text mr-3">
            {{ $t('button.back') }}
          </v-btn>
          <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
            PDF
          </button>
        </v-row>

        <v-card class="profile-header-card mb-4" elevation="2">
          <div class="profile-header-stripe"></div>
          <div class="profile-header-body">
            <v-avatar size="96" tile class="profile-avatar">
              <img :src="personItems[0] ? personItems[0].pic : ''" />
            </v-avatar>
            <div class="profile-header-info">
              <div class="profile-name">{{ staffItems[0] ? staffItems[0].psndetails : '' }}</div>
              <div class="profile-sub" v-if="staffItems[0]">
                <span class="profile-chip">{{ staffItems[0].staffcode }}</span>
                <span class="profile-chip chip-company">{{ staffItems[0].compnyname }}</span>
              </div>
            </div>
          </div>
        </v-card>

        <v-card class="info-card mb-4" elevation="1">
          <div class="info-card-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            {{ $t('reporpersonandstaffdetailssummary.basicinfo') }}
          </div>
          <div class="info-card-body" v-if="personItems[0]">
            <div class="info-grid">
              <div class="info-row">
                <span class="info-label">{{ $t('columns.name') }}</span>
                <span class="info-value" style="grid-column:span 3">{{ personItems[0].psnname }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('recpersonalinfo.idno') }}</span>
                <span class="info-value">{{ personItems[0].idno }}</span>
                <span class="info-label">{{ $t('recpersonalinfo.salutation') }}</span>
                <span class="info-value">{{ personItems[0].salutname }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.dob') }}</span>
                <span class="info-value">{{ personItems[0].dob }} <span class="age-badge">{{ ageYear }}Y {{ ageMonth }}M</span></span>
                <span class="info-label">{{ $t('recpersonalinfo.maritalstatus') }}</span>
                <span class="info-value">{{ personItems[0].marstatname }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.gender') }}</span>
                <span class="info-value">{{ personItems[0].gendername }}</span>
                <span class="info-label">{{ $t('recpersonalinfo.marriagedate') }}</span>
                <span class="info-value">{{ personItems[0].mrgdate }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('recpersonalinfo.nationality') }}</span>
                <span class="info-value">{{ personItems[0].ntlyname }}</span>
                <span class="info-label">{{ $t('recpersonalinfo.race') }} &amp; {{ $t('recpersonalinfo.religion') }}</span>
                <span class="info-value">{{ personItems[0].racename }} &amp; {{ personItems[0].rlgnname }}</span>
              </div>
            </div>
          </div>
        </v-card>

        <v-card class="info-card mb-4" elevation="1">
          <div class="info-card-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 10a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 8 8l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            {{ $t('reporpersonandstaffdetailssummary.contactinfo') }}
          </div>
          <div class="info-card-body" v-if="showConDet && contactItems[0]">
            <div class="info-grid">
              <div class="info-row">
                <span class="info-label">{{ $t('columns.email') }}</span>
                <span class="info-value" style="grid-column:span 3">{{ contactItems[0].email }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('reccontactdetails.hp_no') }}</span>
                <span class="info-value" style="grid-column:span 3">{{ contactItems[0].hpno }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('reccontactdetails.correspondanceaddress') }}</span>
                <span class="info-value" style="grid-column:span 3">
                  <span v-if="showAddr1A">{{ contactItems[0].correspondanceaddr1 }}, </span>
                  <span v-if="showAddr1B">{{ contactItems[0].correspondanceaddr2 }}, </span>
                  <span v-if="showAddr1C">{{ contactItems[0].correspondanceaddr3 }}, </span>
                  {{ contactItems[0].poscode }} {{ contactItems[0].cityname }} {{ contactItems[0].cntryname }}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('reccontactdetails.permanentaddress') }}</span>
                <span class="info-value" style="grid-column:span 3">
                  <span v-if="showAddr2A">{{ contactItems[0].permanentaddr1 }}, </span>
                  <span v-if="showAddr2B">{{ contactItems[0].permanentaddr2 }}, </span>
                  <span v-if="showAddr2C">{{ contactItems[0].permanentaddr3 }}, </span>
                  {{ contactItems[0].permanentposcode }} {{ contactItems[0].permanentcityname }} {{ contactItems[0].permanentcntryname }}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('reccontactdetails.emergencycontact_1') }}</span>
                <span class="info-value">{{ contactItems[0].emergencycontact1 }}</span>
                <span class="info-label">{{ $t('reccontactdetails.emergencycontactno_1') }}</span>
                <span class="info-value">{{ contactItems[0].contactno1 }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('reccontactdetails.emergencycontact_2') }}</span>
                <span class="info-value">{{ contactItems[0].emergencycontact2 }}</span>
                <span class="info-label">{{ $t('reccontactdetails.emergencycontactno_2') }}</span>
                <span class="info-value">{{ contactItems[0].contactno2 }}</span>
              </div>
            </div>
          </div>
        </v-card>

        <v-card class="info-card mb-4" elevation="1">
          <div class="info-card-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
            {{ $t('reporpersonandstaffdetailssummary.staffinfo') }}
          </div>
          <div class="info-card-body">
            <div class="info-grid" v-if="showStaff && staffItems[0]">
              <div class="info-row">
                <span class="info-label">{{ $t('columns.company') }}</span>
                <span class="info-value" style="grid-column:span 3">{{ staffItems[0].compnyname }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.staffcode') }}</span>
                <span class="info-value">{{ staffItems[0].staffcode }}</span>
                <span class="info-label"></span><span class="info-value"></span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('recstaffdetails.hiredate') }}</span>
                <span class="info-value">{{ staffItems[0].hiredate }}</span>
                <span class="info-label">{{ $t('reporalertlisting.servicedate') }}</span>
                <span class="info-value">{{ staffItems[0].servicedate }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('reporalertlisting.dueforconfirmationdate') }}</span>
                <span class="info-value" style="grid-column:span 3">{{ staffItems[0].dueconfirmdate }}</span>
              </div>
            </div>
            <v-divider class="my-3" v-if="showStaffMov && staffmovItems[0]"></v-divider>
            <div class="info-grid" v-if="showStaffMov && staffmovItems[0]">
              <div class="info-row">
                <span class="info-label">{{ $t('columns.branch') }}</span>
                <span class="info-value">{{ staffmovItems[0].brchname }} - {{ staffmovItems[0].brchcode }}</span>
                <span class="info-label">{{ $t('columns.division') }}</span>
                <span class="info-value">{{ staffmovItems[0].divnname }} - {{ staffmovItems[0].divncode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.department') }}</span>
                <span class="info-value">{{ staffmovItems[0].deptname }} - {{ staffmovItems[0].deptcode }}</span>
                <span class="info-label">{{ $t('columns.section') }}</span>
                <span class="info-value">{{ staffmovItems[0].sectioname }} - {{ staffmovItems[0].sectiocode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.unit') }}</span>
                <span class="info-value">{{ staffmovItems[0].unitname }} - {{ staffmovItems[0].unitcode }}</span>
                <span class="info-label">{{ $t('columns.position') }}</span>
                <span class="info-value">{{ staffmovItems[0].posdesc }} - {{ staffmovItems[0].poscode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.grade') }}</span>
                <span class="info-value">{{ staffmovItems[0].grddesc }} - {{ staffmovItems[0].grdcode }}</span>
                <span class="info-label">{{ $t('columns.employmenttype') }}</span>
                <span class="info-value">{{ staffmovItems[0].emptypedesc }} - {{ staffmovItems[0].emptype }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('columns.job') }}</span>
                <span class="info-value" style="grid-column:span 3">{{ staffmovItems[0].jobtitle }} - {{ staffmovItems[0].jobcode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('recstaffdetails.basicsalary') }}</span>
                <span class="info-value"><strong>{{ staffmovItems[0].crcycode }} {{ staffmovItems[0].newbasicsal }}</strong></span>
                <span class="info-label">{{ $t('salfreq') }}</span>
                <span class="info-value">{{ staffmovItems[0].basicfreqcode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('recstaffdetails.contractperiod') }}</span>
                <span class="info-value">{{ staffmovItems[0].contrprd }}</span>
                <span class="info-label">{{ $t('reporalertlisting.contractexpirydate') }}</span>
                <span class="info-value">{{ staffmovItems[0].contrenddate }}</span>
              </div>
            </div>
          </div>
        </v-card>

        <v-card class="info-card mb-4" elevation="1">
          <div class="info-card-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
            {{ $t('reporpersonandstaffdetailssummary.statutoryandbankacc') }}
          </div>
          <div class="info-card-body">
            <div class="info-grid" v-if="personstatItems.length > 0 || showStaffBank">
              <div class="info-row" v-for="item in personstatItems" :key="item.vendorcatdesc">
                <span class="info-label">{{ item.vendorcatdesc }}</span>
                <span class="info-value">{{ item.refno }}</span>
                <span class="info-label"></span>
                <span class="info-value">{{ item.refcode }} - {{ item.refnum }}</span>
              </div>
              <div class="info-row" v-if="showStaffBank && staffbankaccItems[0]">
                <span class="info-label">{{ $t('setupcompanybankaccount.bank') }}</span>
                <span class="info-value">{{ staffbankaccItems[0].bankcode }} - {{ staffbankaccItems[0].staffaccountno }}</span>
                <span class="info-label"></span>
                <span class="info-value">{{ staffbankaccItems[0].bankaccountcode }} - {{ staffbankaccItems[0].bankaccountno }}</span>
              </div>
            </div>
            <div class="no-data" v-if="personstatItems.length === 0 && !showStaffBank">{{ $t('recstaffdetails.nodatafound') }}</div>
          </div>
        </v-card>

        <v-card class="info-card mb-4" elevation="1">
          <div class="info-card-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            {{ $t('reporpersonandstaffdetailssummary.grpassignmentinfo') }}
          </div>
          <div class="info-card-body">
            <div class="info-grid" v-if="showGroupAssign">
              <div class="info-row" v-for="item in groupassignmentdItems" :key="item.gtypedesc">
                <span class="info-label">{{ item.gtypedesc }}</span>
                <span class="info-value" style="grid-column:span 3">{{ item.valvaluecodedesc }} - {{ item.valvaluecode }}</span>
              </div>
            </div>
            <div class="no-data" v-if="!showGroupAssign">{{ $t('recstaffdetails.nodatafound') }}</div>
          </div>
        </v-card>

      </v-form>
    </v-container>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import moment from "moment";
import "jspdf-autotable";

export default {
  props: {
    parentObject: Object,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('reportsparam.invalidemail');
        },
      },

      data: {
        formData: {
          asatdate: this.$route.params.formData.asatdate,
          id: this.$route.params.formData.id,
        }
      },

      ageYear: null,
      ageMonth: null,

      staffItems: [],
      personItems: [],
      contactItems: [],
      staffmovItems: [],
      personstatItems: [],
      staffbankaccItems: [],
      groupassignmentdItems: [],

      goBtn: false,

      showStaff: true,
      showPerson: true,
      showConDet: true,
      showPersonStat: true,
      showStaffBank: true,
      showGroupAssign: true,
      showStaffMov: true,

      showAddr1A: true,
      showAddr1B: true,
      showAddr1C: true,
      showAddr2A: true,
      showAddr2B: true,
      showAddr2C: true,
    }
  },
  
  methods: {
    backButton() {
      this.$router.push({ name: "parameterpersonandstaff" });
    },

    loadStaff() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/staff/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.staffItems = res.data.rec;

            for(let i = 0; i < vm.staffItems.length; i++) {
              vm.staffItems[i].hiredate = moment(vm.staffItems[i].hiredate).format("DD-MM-YYYY");
              vm.staffItems[i].servicedate = moment(vm.staffItems[i].servicedate).format("DD-MM-YYYY");
              vm.staffItems[i].dueconfirmdate = moment(vm.staffItems[i].dueconfirmdate).format("DD-MM-YYYY");
            }

            if(vm.staffItems.length == 0) {
              vm.showStaff = false;
            }
          })
    },

    loadPerson() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/person/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.personItems = res.data.rec;

            for(let i = 0; i < vm.personItems.length; i++) {
              vm.personItems[i].dob = moment(vm.personItems[i].dob).format("DD-MM-YYYY");
              var dobYear = moment(vm.personItems[i].dob, "DD-MM-YYYY").format("YYYY");
              var dobMonth = moment(vm.personItems[i].dob, "DD-MM-YYYY").format("MM");
              var currentYear = moment(new Date()).format("YYYY");
              var currentMonth = moment(new Date()).format("MM");
              vm.ageYear = currentYear - dobYear;
              vm.ageMonth = currentMonth - dobMonth;

              if(vm.ageMonth < 0){
                vm.ageYear -= 1;
                vm.ageMonth += 12;
              }
            }

            if(vm.personItems.length == 0) {
              vm.showPerson = false;
            }
          })
    },

    loadContactDetails() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/contactdetails/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.contactItems = res.data.rec;

            if(vm.contactItems.length < 1) {
              vm.showConDet = false;
            }
            else{
              if(vm.contactItems[0].correspondanceaddr1 == null) {
                vm.showAddr1A = false;
              }
              if(vm.contactItems[0].correspondanceaddr2 == null) {
                vm.showAddr1B = false;
              }
              if(vm.contactItems[0].correspondanceaddr3 == null) {
                vm.showAddr1C = false;
              }
              if(vm.contactItems[0].permanentaddr1 == null) {
                vm.showAddr2A = false;
              }
              if(vm.contactItems[0].permanentaddr2 == null) {
                vm.showAddr2B = false;
              }
              if(vm.contactItems[0].permanentaddr3 == null) {
                vm.showAddr2C = false;
              }
            }
          })
    },

    loadStaffMov() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/staffmov/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.staffmovItems = res.data.rec;

            if(vm.staffmovItems.length < 1) {
              vm.showStaffMov = false;
            }

            for(let i = 0; i < vm.staffmovItems.length; i++) {
              vm.staffmovItems[i].newbasicsal = vm.staffmovItems[i].newbasicsal.toFixed(2);
              vm.staffmovItems[i].newbasicsal = vm.staffmovItems[i].newbasicsal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
          })
    },

    loadPersonStatInfo() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/personstatutoryinfo/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.personstatItems = res.data.rec;

            if(vm.personstatItems.length < 1) {
              vm.showPersonStat = false;
            }
          })
    },

    loadStaffBankAccount() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/staffbankaccount/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.staffbankaccItems = res.data.rec;

            if(vm.staffbankaccItems.length < 1) {
              vm.showStaffBank = false;
            }
          })
    },

    loadGroupAssignmentD() {
      this.goBtn = true;
      const vm = this;

      this.$store.dispatch('post', {url: `/personandstaff/groupassignmentd/${this.$store.getters.userId}`,
          payload: this.data})
          .then(res => {
            vm.groupassignmentdItems = res.data.rec;

            if(vm.groupassignmentdItems.length < 1) {
              vm.showGroupAssign = false;
            }

            for(let i = 0; i < vm.groupassignmentdItems.length; i++) {
              const word = vm.groupassignmentdItems[i].gtypedesc;
              vm.groupassignmentdItems[i].gtypedesc = word.charAt(0) + word.substring(1).toLowerCase();
            }
          })
    },

    printPDF() {
      const doc = new jsPDF({
        orientation: "portrait",
      });

      doc.setFontSize(12); //set font size to 10
      doc.setTextColor(76, 175, 80); //set font color to green

      doc.text(this.staffItems[0].psndetails.toString(), 10, 10);

      doc.setFontSize(8); //set font size to 6
      doc.setFontType("bold"); //set font type to bold
      doc.setTextColor(33, 150, 243); //set font color to blue

      doc.text(this.$t('reporpersonandstaffdetailssummary.basicinfo'), 10, 20);

      doc.setTextColor(0, 0, 0); //set font type to black

      doc.text(this.$t('columns.name'), 10, 26);
      doc.text(this.$t('recfamdetails.icno'), 10, 32);
      doc.text(this.$t('columns.dob'), 10, 38);
      doc.text(this.$t('columns.gender'), 10, 44);
      doc.text(this.$t('recpersonalinfo.nationality'), 10, 50);

      doc.setFontType("normal"); //set font type to normal

      doc.text(this.checkEmpty(this.personItems[0].psnname), 50, 26);
      doc.text(this.checkEmpty(this.personItems[0].idno), 50, 32);
      doc.text(this.checkEmpty(this.personItems[0].dob), 50, 38);
      doc.text(this.checkEmpty(this.personItems[0].gendername), 50, 44);
      doc.text(this.checkEmpty(this.personItems[0].ntlyname), 50, 50);

      doc.setFontType("bold"); //set font type to bold

      doc.text(this.$t('recpersonalinfo.salutation'), 120, 32, "right");
      doc.text(this.$t('recpersonalinfo.maritalstatus'), 120, 38, "right");
      doc.text(this.$t('recpersonalinfo.marriagedate'), 120, 44, "right");
      doc.text(this.$t('recpersonalinfo.raceandreligion'), 120, 50, "right");

      doc.setFontType("normal"); //set font type to normal

      doc.text(this.checkEmpty(this.personItems[0].salutname), 125, 32);
      doc.text(this.checkEmpty(this.personItems[0].marstatname), 125, 38);
      doc.text(this.checkEmpty(this.personItems[0].mrgdate), 125, 44);
      doc.text(this.checkEmpty(this.personItems[0].racename) + " & " + this.checkEmpty(this.personItems[0].rlgnname), 125, 50);

      if(this.showPerson == false) {
        doc.addImage(this.personItems[0].pic, 167, 20, 32, 32);
      }

      doc.setFontType("bold"); //set font type to bold
      doc.setTextColor(33, 150, 243); //set font color to blue

      doc.text("Contact Details", 10, 60);

      doc.setTextColor(0, 0, 0); //set font type to black

      doc.text(this.$t('columns.email'), 10, 66);
      doc.text(this.$t('reccontactdetails.hp_no'), 10, 72);
      doc.text(this.$t('reccontactdetails.correspondanceaddress'), 10, 78);
      doc.text(this.$t('reccontactdetails.permanentaddress'), 10, 84);
      doc.text(this.$t('reccontactdetails.emergencycontact_1'), 10, 90);
      doc.text(this.$t('reccontactdetails.emergencycontact_2'), 10, 96);
      doc.text(this.$t('reccontactdetails.emergencycontactno_1'), 10, 102);
      doc.text(this.$t('reccontactdetails.emergencycontactno_2'), 10, 108);

      doc.setFontType("normal"); //set font type to normal

      if(this.showConDet == true){
        doc.text(this.checkEmpty(this.contactItems[0].email), 50, 66);
        doc.text(this.checkEmpty(this.contactItems[0].hpno), 50, 72);
        doc.text(this.checkEmpty(this.contactItems[0].correspondanceaddr1 + ", ") + this.checkEmpty(this.contactItems[0].correspondanceaddr2 + ", ") + this.checkEmpty(this.contactItems[0].correspondanceaddr3 + ", ") + this.checkEmpty(this.contactItems[0].poscode + " ") + this.checkEmpty(this.contactItems[0].cityname + " ") + this.checkEmpty(this.contactItems[0].cntryname + " "), 50, 78);
        doc.text(this.checkEmpty(this.contactItems[0].permanentaddr1 + ", ") + this.checkEmpty(this.contactItems[0].permanentaddr2 + ", ") + this.checkEmpty(this.contactItems[0].permanentaddr3 + ", ") + this.checkEmpty(this.contactItems[0].permanentposcode + " ") + this.checkEmpty(this.contactItems[0].permanentcityname + " ") + this.checkEmpty(this.contactItems[0].permanentcntryname + " "), 50, 84);
        doc.text(this.checkEmpty(this.contactItems[0].emergencycontact1), 50, 90);
        doc.text(this.checkEmpty(this.contactItems[0].emergencycontact2), 50, 96);
        doc.text(this.checkEmpty(this.contactItems[0].contactno1), 50, 102);
        doc.text(this.checkEmpty(this.contactItems[0].contactno2), 50, 108);
      }

      doc.setFontType("bold"); //set font type to bold
      doc.setTextColor(33, 150, 243); //set font color to blue

      doc.text(this.$t('reporpersonandstaffdetailssummary.staffinfo'), 10, 118);

      doc.setTextColor(0, 0, 0); //set font type to black

      doc.text(this.$t('columns.company'), 10, 124);
      doc.text(this.$t('columns.staffcode'), 10, 130);
      doc.text(this.$t('recstaffdetails.hiredate'), 10, 136);
      doc.text(this.$t('reporalertlisting.dueforconfirmationdate'), 10, 142);
      doc.text(this.$t('columns.branch'), 10, 148);
      doc.text(this.$t('columns.division'), 10, 154);
      doc.text(this.$t('columns.department'), 10, 160);
      doc.text(this.$t('columns.section'), 10, 166);
      doc.text(this.$t('columns.unit'), 10, 172);
      doc.text(this.$t('columns.position'), 10, 178);
      doc.text(this.$t('columns.grade'), 10, 184);
      doc.text(this.$t('columns.employmenttype'), 10, 190);
      doc.text(this.$t('columns.job'), 10, 196);
      doc.text(this.$t('recstaffdetails.basicsalary'), 10, 202);
      doc.text(this.$t('recstaffdetails.contractperiod'), 10, 208);

      doc.setFontType("normal"); //set font type to normal

      if(this.showStaff == true) {
        doc.text(this.checkEmpty(this.staffItems[0].compnyname), 50, 124);
        doc.text(this.checkEmpty(this.staffItems[0].staffcode), 50, 130);
        doc.text(this.checkEmpty(this.staffItems[0].hiredate), 50, 136);
        doc.text(this.checkEmpty(this.staffItems[0].dueconfirmdate), 50, 142);
      }

      if(this.showStaffMov == true) {
        doc.text(this.checkEmptyDash(this.staffmovItems[0].brchname, this.staffmovItems[0].brchcode), 50, 148);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].divnname, this.staffmovItems[0].divncode), 50, 154);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].deptname, this.staffmovItems[0].deptcode), 50, 160);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].sectioname, this.staffmovItems[0].sectiocode), 50, 166);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].unitname, this.staffmovItems[0].unitcode), 50, 172);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].posdesc, this.staffmovItems[0].poscode), 50, 178);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].grddesc, this.staffmovItems[0].grdcode), 50, 184);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].emptypedesc, this.staffmovItems[0].emptype), 50, 190);
        doc.text(this.checkEmptyDash(this.staffmovItems[0].jobtitle, this.staffmovItems[0].jobcode), 50, 196);
        doc.text(this.checkEmptyMoney(this.staffmovItems[0].crcycode, this.staffmovItems[0].newbasicsal), 50, 202);
        doc.text(this.checkEmpty(this.staffmovItems[0].contrprd), 50, 208);
      }

      doc.setFontType("bold"); //set font type to bold

      doc.text(this.$t('reporalertlisting.servicedate'), 120, 136, "right");
      doc.text(this.$t('salfreq'), 120, 202, "right");
      doc.text(this.$t('reporalertlisting.contractexpirydate'), 120, 208, "right");

      doc.setFontType("normal"); //set font type to normal
      
      if(this.showStaff == true) {
        doc.text(this.checkEmpty(this.staffItems[0].servicedate), 125, 136);
      }

      if(this.showStaffMov == true) {
        doc.text(this.checkEmpty(this.staffmovItems[0].basicfreqcode), 125, 202);
        doc.text(this.checkEmpty(this.staffmovItems[0].contrenddate), 125, 208);
      }

      doc.setFontType("bold"); //set font type to bold
      doc.setTextColor(33, 150, 243); //set font color to blue

      doc.text(this.$t('reporpersonandstaffdetailssummary.statutoryandbankacc'), 10, 218);

      doc.setTextColor(0, 0, 0); //set font type to black

      var number = 218;

      for(let i = 0; i < this.personstatItems.length; i++) {
        number += 6;
        doc.setFontType("bold"); //set font type to bold
        doc.text(this.checkEmpty(this.personstatItems[i].vendorcatdesc), 10, number);
        doc.setFontType("normal"); //set font type to normal
        doc.text(this.checkEmpty(this.personstatItems[i].refno), 50, number);
        doc.text(this.checkEmptyDash(this.personstatItems[i].refcode, this.personstatItems[i].refnum), 100, number);
      }

      for(let i = 0; i < this.staffbankaccItems.length; i++) {
        number += 6;
        doc.setFontType("bold"); //set font type to bold
        doc.text(this.$t('bank'), 10, number);
        doc.setFontType("normal"); //set font type to normal
        doc.text(this.checkEmptyDash(this.staffbankaccItems[i].bankcode, this.staffbankaccItems[i].staffaccountno), 50, number);
        doc.text(this.checkEmptyDash(this.staffbankaccItems[i].bankaccountcode, this.staffbankaccItems[i].bankaccountno), 100, number);
      }

      if(this.showPersonStat == false && this.showStaffBank == false) {
        number += 6;
        doc.setFontType("normal"); //set font type to normal
        doc.text(this.$t('recstaffdetails.nodatafound'), 10, number);
      }

      doc.setFontType("bold"); //set font type to bold
      doc.setTextColor(33, 150, 243); //set font color to blue

      number += 10;

      doc.text(this.$t('reporpersonandstaffdetailssummary.grpassignmentinfo'), 10, number);

      doc.setTextColor(0, 0, 0); //set font type to black

      for(let i = 0; i < this.groupassignmentdItems.length; i++) {
        number += 6;
        doc.setFontType("bold"); //set font type to bold
        doc.text(this.checkEmpty(this.groupassignmentdItems[i].gtypedesc), 10, number);
        doc.setFontType("normal"); //set font type to normal
        doc.text(this.checkEmptyDash(this.groupassignmentdItems[i].valvaluecodedesc, this.groupassignmentdItems[i].valvaluecode), 50, number);
      }

      if(this.showGroupAssign == false) {
        number += 6;
        doc.setFontType("normal"); //set font type to normal
        doc.text(this.$t('recstaffdetails.nodatafound'), 10, number);
      }

      doc.save(this.staffItems[0].psndetails.toString() + this.formData.asatdate.toString() + '" ' + this.$t('personandstaffdetailssummary') + ' "' ); 
    },

    checkEmpty(variable) {
      if(variable == null) {
        return "";
      }
      else if(variable == null + ", ") {
        return "";
      }
      else if(variable == null + " ") {
        return "";
      }
      else {
        return variable;
      }
    },

    checkEmptyDash(variable1, variable2) {
      if(variable1 == null && variable2 == null) {
        return "";
      }
      else if(variable1 != null && variable2 == null) {
        return variable1;
      }
      else if(variable1 == null && variable2 != null) {
        return variable2;
      }
      else {
        return variable1 + " - " + variable2;
      }
    },

    checkEmptyMoney(variable1, variable2) {
      if(variable1 == null && variable2 == null) {
        return "";
      }
      else if(variable1 != null && variable2 == null) {
        return variable1;
      }
      else if(variable1 == null && variable2 != null) {
        return variable2;
      }
      else {
        return variable1 + " " + variable2;
      }
    }
  },

  mounted() {},

  created() {
    const vm = this;
    vm.formData = this.$route.params.formData;

    this.loadStaff();
    this.loadPerson();
    this.loadContactDetails();
    this.loadStaffMov();
    this.loadPersonStatInfo();
    this.loadStaffBankAccount();
    this.loadGroupAssignmentD();
  },
};
</script>

<style scoped>
.profile-header-card { border-radius: 12px !important; overflow: hidden; border: 1px solid #E8EDF5 !important; }
.profile-header-stripe { height: 4px; background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%); }
.profile-header-body { display: flex; align-items: center; gap: 20px; padding: 20px 24px; }
.profile-avatar { border-radius: 10px !important; border: 3px solid #E8EDF5; }
.profile-avatar img { object-fit: cover; width: 100%; height: 100%; }
.profile-name { font-size: 1.2rem; font-weight: 700; color: #1E293B; margin-bottom: 8px; }
.profile-sub { display: flex; gap: 8px; flex-wrap: wrap; }
.profile-chip { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 0.78rem; font-weight: 600; background: #EEF2FF; color: #4F6BFF; border: 1px solid #C7D2FE; }
.chip-company { background: #F0FDF4; color: #059669; border-color: #A7F3D0; }
.info-card { border-radius: 10px !important; border: 1px solid #E8EDF5 !important; }
.info-card-header { display: flex; align-items: center; gap: 8px; padding: 12px 20px; font-size: 0.88rem; font-weight: 700; color: #4F6BFF; background: #F8FAFF; border-bottom: 1px solid #E8EDF5; }
.info-card-body { padding: 4px 20px 12px; }
.info-grid { width: 100%; }
.info-row { display: grid; grid-template-columns: 170px 1fr 170px 1fr; gap: 0 12px; border-bottom: 1px solid #F1F5F9; padding: 9px 0; align-items: start; }
.info-row:last-child { border-bottom: none; }
.info-label { font-size: 0.82rem; font-weight: 600; color: #64748B; line-height: 1.4; }
.info-value { font-size: 0.85rem; color: #1E293B; line-height: 1.4; }
.age-badge { display: inline-block; font-size: 0.72rem; font-weight: 600; background: #EEF2FF; color: #4F6BFF; padding: 1px 7px; border-radius: 10px; margin-left: 6px; }
.no-data { padding: 16px 0; color: #94A3B8; font-size: 0.85rem; font-style: italic; }
.export-icon-btn { display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 8px; border: none; font-size: 0.8rem; font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.15s; }
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
</style>